import { createSlice } from "@reduxjs/toolkit"
import {ensureWorkspaceTemplate} from "../utils/reduxUtilities"

const initialState = {
	isOpen: false,
	textBoxContent: null,
}
const ensureWorkspace = (state, workspaceId) => ensureWorkspaceTemplate(state, workspaceId, initialState)
export const copyCitationsModalSlice = createSlice({
	name: "copyCitationsModal",
	initialState: {
		byWorkspace: {}
	},
	reducers: {
		openModal: (state, action) => {
			const workspace = ensureWorkspace(state, action.payload)
			workspace.isOpen = true
		},
		closeModal: (state, action) => {
			const workspace = ensureWorkspace(state, action.payload)
			workspace.isOpen = false
		},
		clearModalAndClose: (state, action) => {
			const workspace = ensureWorkspace(state, action.payload)
			workspace.isOpen = initialState.isOpen
			workspace.textBoxContent = initialState.textBoxContent
		},
		setTextBoxContent: (state, action) => {
			const { workspaceId, textBoxContent } = action.payload
			const workspace = ensureWorkspace(state, workspaceId)
			workspace.textBoxContent = textBoxContent
		},
	},
})
export const { openModal, closeModal, clearModalAndClose, setTextBoxContent } =
	copyCitationsModalSlice.actions

export const modalIsOpen = (state, workspaceId) => state.copyCitationsModal.byWorkspace[workspaceId]?.isOpen ?? initialState.isOpen

export default copyCitationsModalSlice.reducer
